import React, { useEffect, useState } from "react";
import { LoginInputs } from "../../../../Components/LoginInputs";
import { SignIn } from "../../../../Components/SignIn";
import { InputContainer, InputButton, HelperSpan, Span } from "./styles";
import { SignInButton } from "../../../../Components/Buttons/SingnInButton";
import { RememberPassword } from "../../../../Components/RememberPassword";
import { useCartorio } from "../../../../Hooks/cartorio";
import { validateCPF } from "../../../../Services/validateCPF";
import { validateCNPJ } from "../../../../Services/validateCPNJ";
import { cnpjMask } from "../../../../Services/cnpjMask";
import { cpfMask } from "../../../../Services/cpfMask";
import { limpa_cpf_cnpj } from "../../../../Services/limpa_cpf_cnpj";
import { Alert } from "../../../../Components/Error/Alert";
import { cartorioKey } from "../../../../Utils/localStorageKeys";
import { Link } from "react-router-dom";
import { app_base_url } from "../../../../Utils/baseUrl";
import { useNavigate } from "react-router-dom";
export function SignInCartorio() {

  const navigate = useNavigate();
  const [cpf_cnpj, setCpfCnpj] = useState("");
  const [senha, setSenha] = useState("");
  const [error, setError] = useState("");
  const [errorTitle, setErrorTitle] = useState("");
  const [loading, setLoading] = useState(false);

  const { signInCartorio,cartorio } = useCartorio();

  function handleCPF_CNPJ(cpf_cnpj: string) {
    setCpfCnpj(cpf_cnpj);
    if (cpf_cnpj.length <= 14) {
      setCpfCnpj(cpfMask(cpf_cnpj));
    } else {
      setCpfCnpj(cnpjMask(cpf_cnpj));
    }
  }

  function handleSenha(pass: string) {
    setSenha(pass.trim());
  }

  async function handleSignIn() {
    setLoading(true);

    const cpf_cnpj_limpo = limpa_cpf_cnpj(cpf_cnpj);

    try {
      if (cpf_cnpj_limpo.length == 11 || cpf_cnpj_limpo.length < 11) {
        if (!validateCPF(cpf_cnpj_limpo)) {
          setError("O CPF digitado é inválido!");
          setErrorTitle("CPF inválido");

          return;
        }
      }

      if (cpf_cnpj_limpo.length > 11) {
        if (!validateCNPJ(cpf_cnpj_limpo)) {
          setError("O CNPJ digitado é inválido!");
          setErrorTitle("CNPJ inválido!");
         return;
        }
      }

      if (senha.length == 0) {
        setError("O campo senha não pode ser vázio!");
        setErrorTitle("Senha inválida!");
        return;
      }
      await signInCartorio(cpf_cnpj_limpo, senha, false);
    } catch (error) {
      setError(
        `Sua combinação de ${
          cpf_cnpj_limpo.length <= 11 ? "CPF" : "CNPJ"
        } e senha estão incorretos!  `
      );
      setErrorTitle("Dados de login inválidos!");
    } finally {
      setLoading(false);
    }
  }


  return (
    <SignIn
      children={
        <>
          <InputContainer>
            <LoginInputs
              placeholder="CPF/CNPJ"
              type="cnpj"
              execute={handleCPF_CNPJ}
              value={cpf_cnpj}
            />
          </InputContainer>
          <InputContainer>
            <LoginInputs
              placeholder="SENHA"
              type="pass"
              execute={handleSenha}
              value={senha}
            />
          </InputContainer>

          <InputButton>
            <SignInButton
              text="LOGIN"
              enable={false}
              type={"login"}
              execute={handleSignIn}
              loading={loading}
            />
          </InputButton>
        
          <InputButton>
          
         <SignInButton
              text="CADASTRAR-SE"
              enable={false}
              type={"cadastro"}
              execute={() => {navigate(`${app_base_url}/cartorio/cadastrar`)}}
            />
             
             </InputButton>
             <HelperSpan onClick={() => navigate(`${app_base_url}/cartorio/funcionario`)}>
              <Span>Logar como funcionário</Span>
              
             </HelperSpan>

          <HelperSpan>
            <RememberPassword />
          </HelperSpan>
          <Alert
            message={error}
            onClose={() => {
              setError("");
            }}
            open={error.length > 0}
            title={errorTitle}
          />
        </>
      }
    />
  );
}
